var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgColortileNotAvailable = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 480,
  height: 360,
  baseProfile: "full",
  style: {
    zoom: 2
  }
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#f1f1f1",
  d: "M-28.75-4h480v460h-480z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#7a7a7a",
  transform: "translate(0 63)"
}, /*#__PURE__*/React.createElement("path", {
  strokeWidth: 2,
  d: "m202.5 116.5 53.5-48"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M198 72.5h60.5v41H198z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 205,
  cy: 86,
  r: 6,
  fill: "none",
  transform: "translate(5)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  strokeWidth: 1,
  d: "m199 113.25 22-20.5 14.5 12 11-10.5 11.5 8.5"
}))), /*#__PURE__*/React.createElement("text", {
  xmlSpace: "preserve",
  x: 227.5,
  y: 199,
  fill: "#7a7a7a",
  fontFamily: "Arial",
  fontSize: 8,
  style: {
    outlineStyle: "none"
  },
  textAnchor: "middle",
  textRendering: "geometricPrecision"
}, "Image unavailable at the moment."), /*#__PURE__*/React.createElement("text", {
  xmlSpace: "preserve",
  x: 227,
  y: 202.5,
  fill: "#7a7a7a",
  fontFamily: "Arial",
  fontSize: 8,
  style: {
    outlineStyle: "none"
  },
  textAnchor: "middle",
  textRendering: "geometricPrecision",
  transform: "translate(0 11)"
}, "Please check back later."));
export { SvgColortileNotAvailable as ReactComponent };
export default "data:image/svg+xml;base64,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";